import { canDo } from './Permissions/Rbac';

const useAction = (props) => {
    const {canData, noUseCanData, render} = props;
    let response = null;
    if(noUseCanData || canDo({...canData})){
        response = render;
    }
    return response;
}
export default useAction;